module.exports = __webpack_public_path__ + "img/diente_sexo.dae3f9ef.svg";